// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2Zb6X","choiceBoxes":"toolbarselects_choiceBoxes__26XF6","simpleField":"toolbarselects_simpleField__1ahOo"};